<script setup>
  import {computed, inject, onBeforeUnmount, onMounted, ref} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "ComponentAccordionItem",
  });

  const props = defineProps({
    title: {
      type: String,
      default: "",
    },
    initOpened: {
      type: Boolean,
      default: false,
    },
  });

  const accordionProvider = inject("accordionProvider");

  const id = ref(null);

  onMounted(() => {
    id.value = accordionProvider.register(props.initOpened);
  });

  onBeforeUnmount(() => {
    if (id.value !== null) {
      accordionProvider.unregister(id.value);
    }
  });

  const isOpen = computed(() => id.value !== null && accordionProvider.state.selectedId === id.value);

  const open = () => (accordionProvider.state.selectedId = id.value);
  const close = () => {
    if (accordionProvider.state.selectedId === id.value) {
      accordionProvider.state.selectedId = null;
    }
  };

  const toggle = () => {
    if (id.value !== null) accordionProvider.select(id.value);
  };

  defineExpose({
    isOpen,
    open,
    close,
    toggle,
  });
</script>

<template>
  <li class="p-1" :data-test="getTestId('accordion-item')">
    <button
      type="button"
      class="flex w-full cursor-pointer flex-row items-center gap-6 px-5 py-3 select-none"
      :class="{'bg-gray-50': isOpen}"
      @click="toggle"
    >
      <slot name="icon" />

      <div class="text-left" :class="{'font-bold': isOpen}">
        {{ title }}
        <slot name="title" />
      </div>

      <ComponentIcon class="ml-auto text-2xl" :class="{'font-bold': isOpen}">
        {{ isOpen ? "expand_less" : "expand_more" }}
      </ComponentIcon>
    </button>
    <div v-if="isOpen" class="border-t-1 border-gray-300 px-6 py-4">
      <slot />
    </div>
  </li>
</template>
